<template>
	<sf-data-table
		:columns="columns"
		:rows="rows"
		index
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		height="100%"
		paging
		:pageUnit="pageUnit_"
		:pageArray="screen.pageArray"
		:totalSize="totalSize_"
		@changedPage="changedPage"
	>
		<!-- <template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'procId'">
				<span @click="() => onClick(slotProps.row)" :style="{ color: 'blue', fontWeight: 'bold', cursor: 'pointer' }">
					{{ slotProps.row.procId }}
				</span>
			</template>
		</template> -->
	</sf-data-table>
</template>

<script>
// import columns from './columns';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProcessRegistration/store/helpers';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// label: 'Process ID',
					label: this.getMessage_('SWCC000284'),
					// msgKey: 'SWCC000284',
					prop: 'procId',
					// custom: true,
					clickEvent: this.onClick,
					highlight: true
				},
				{
					// label: 'Process Name',
					label: this.getMessage_('SWCC000285'),
					// msgKey: 'SWCC000285',
					prop: 'procName'
				},
				{
					// label: '서비스',
					label: this.getMessage_('SWCC000250'),
					// msgKey: 'SWCC000250',
					prop: 'serviceKind'
				},
				{
					// label: 'Type',
					label: this.getMessage_('SWCC000315'),
					// msgKey: 'SWCC000315',
					prop: 'procType'
				},
				{
					// label: 'Kind',
					label: this.getMessage_('SWCC000314'),
					// msgKey: 'SWCC000314',
					prop: 'procKind'
				}
			];
			// return columns.map(column => ({ ...column, label: this.getMessage_(column.msgKey) }));
		},
		rows() {
			return this.processes.map(process => ({
				...process,
				serviceKind: this.serviceKindConvertor(process.serviceKind),
				procType: this.procTypeConvertor(process.procType),
				procKind: this.procKindConvertor(process.procKind)
			}));
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		excelFunc() {
			const url = `${BASE_URL}/process/v1/plants/${this.user.plantCd}/processes`;
			const params = { url, columns: this.columns };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},

		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.findAllProcesses);
		},
		onClick(selectedRow) {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: 'update',
					show: true,
					selectedRow: {
						...selectedRow,
						serviceKind: this.serviceKindConvertor(selectedRow.serviceKind),
						procType: this.procTypeConvertor(selectedRow.procType),
						procKind: this.procKindConvertor(selectedRow.procKind)
					}
				}
			});
		},
		serviceKindConvertor(serviceKind) {
			switch (serviceKind) {
				case 'D':
					return 'DEMON';
				case 'T':
					return 'TERMINAL';
				case 'W':
					return 'WEB';
				case 'DEMON':
					return 'D';
				case 'TERMINAL':
					return 'T';
				case 'WEB':
					return 'W';
				default:
					return '';
			}
		},
		procTypeConvertor(procType) {
			switch (procType) {
				case 'B':
					return 'IN/OUTPUT';
				case 'I':
					return 'INPUT';
				case 'O':
					return 'OUTPUT';
				case 'P':
					return 'PROCESS';
				case 'IN/OUTPUT':
					return 'B';
				case 'INPUT':
					return 'I';
				case 'OUTPUT':
					return 'O';
				case 'PROCESS':
					return 'P';
				default:
					return '';
			}
		},
		procKindConvertor(procKind) {
			switch (procKind) {
				case '1':
					return 'ORDER';
				case '2':
					return 'MORNITORING';
				case '3':
					return 'MORNITORING(AUTO)';
				case 'ORDER':
					return '1';
				case 'MORNITORING':
					return '2';
				case 'MORNITORING(AUTO)':
					return '3';
				default:
					return '';
			}
		},
		findAllProcesses() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		}
	},
	created() {
		this.findAllProcesses();
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style langType="scss"></style>
